export default "__VITE_PUBLIC_ASSET__ee1efc64__"